// extracted by mini-css-extract-plugin
module.exports = {"root":"icon-button_root__b9_Wq","circle":"icon-button_circle__LEyCY"};